import { IDeleteObraPlanoTreinamentoUseCase } from "../../../presentation/useCases/delete/delete_obra_plano_treinamento_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObraPlanoTreinamentoUseCase
 */

export class DeleteObraPlanoTreinamentoUseCase implements IDeleteObraPlanoTreinamentoUseCase {
  constructor(private readonly repository: IObrasRepository) { }
  async deleteObraPlanoTreinamento(
    IdPlanoTreinamento: number,
    IdObra: number,
  ): Promise<void> {
    await this.repository.deleteObraPlanoTreinamento(IdPlanoTreinamento, IdObra);
  }
}
